import { Dimensions, StyleSheet } from 'react-native';

import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: neutrals.coldGrays.pearl,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: Dimensions.get('window').height,
  },
  contentWrapper: {
    height: '100%',
    width: '100%',
  },
  content: {
    flexGrow: 1,
  },
});
